// @flow
import Raven from 'raven-js';
import createSagaMiddleware from 'redux-saga';

export default createSagaMiddleware({
  onError: (err) => {
    Raven.captureException(err);
  },
});



// WEBPACK FOOTER //
// ./src/store/saga.js